import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'assets/icons/back.svg';
import PaymentHistoryHeader from './header';
import PaymentHistoryList from './history-list';
import { DUMMY_DATA } from './dummyData';
import { ENUM_DATE_RANGE, getDateRangeSelector } from '@cokitchen/cokitchen-components';
import { LOGISTICS_ROUTE_KEYS } from 'utils/constants';

const PaymentHistory = () => {
  const [filters, setFilters] = useState({
    partnerId: '',
    dateRange: {
      range: ENUM_DATE_RANGE.ALL,
      date: getDateRangeSelector(ENUM_DATE_RANGE.ALL)
    }
  });

  return (
    <div>
      <Link
        to={LOGISTICS_ROUTE_KEYS.OVERVIEW}
        className='inline-flex justify-start gap-1 items-center text-[#595959] font-xs mb-6 cursor-pointer'>
        <BackIcon /> Back to overview
      </Link>
      <h1 className='font-semibold text-2xl flex items-center mb-6'>
        Payment History
        <span className='bg-gray-11 inline-block rounded py-1 px-3 ml-3 font-medium text-sm leading-[22px]'>
          N3,200,000
        </span>
      </h1>
      <PaymentHistoryHeader value={filters} onChange={setFilters} />
      <PaymentHistoryList data={DUMMY_DATA} />
    </div>
  );
};

export default PaymentHistory;
